import type { AllRouteEndpoints } from "../routeTypes";
export const engagementLandingPageTemplatesUpdateArchivedStateCacheKeys: AllRouteEndpoints[] = [
  "/engagement/landing_page_templates_data",
];
